import { openBlock as t, createElementBlock as e, createElementVNode as h } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ h("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), v = /* @__PURE__ */ h("path", {
  fill: "#D80027",
  d: "M26.496 14.783h-2.617c.022.287.034.577.034.87 0 1.934-.484 3.809-1.327 5.144-.26.412-.697.993-1.282 1.385v-7.4h-2.608v7.4c-.585-.392-1.023-.973-1.283-1.385-.843-1.335-1.326-3.21-1.326-5.145 0-.292.012-.582.034-.87h-2.617c-.017.287-.026.576-.026.87 0 5.364 2.865 9.565 6.522 9.565s6.521-4.201 6.521-9.565c0-.293-.009-.583-.025-.87Z"
}, null, -1), n = /* @__PURE__ */ h("path", {
  fill: "#6DA544",
  d: "M8.26 9.565h2.61v1.74h2.608v-1.74h2.609v1.74h2.608v-1.74h2.61v1.74h2.608v-1.74h2.608v1.74h2.61v-1.74h2.608v1.74h6.276C34.78 4.614 27.929 0 20 0 12.07 0 5.22 4.614 1.984 11.304h6.277V9.565Z"
}, null, -1), c = /* @__PURE__ */ h("path", {
  fill: "#D80027",
  d: "M31.739 28.696v1.739H29.13v-1.74h-2.608v1.74h-2.609v-1.74h-2.609v1.74h-2.608v-1.74h-2.609v1.74h-2.609v-1.74H10.87v1.74H8.261v-1.74H1.984C5.22 35.386 12.071 40 20 40c7.93 0 14.78-4.614 18.015-11.304H31.74Z"
}, null, -1), s = [
  o,
  v,
  n,
  c
];
function i(d, _) {
  return t(), e("svg", l, [...s]);
}
const a = { render: i };
export {
  a as default,
  i as render
};
